import { useContextError } from "common-frontend-components";
import { QuestionContext } from "./QuestionContext";

export default function useQuestionResponse() {
    return useContextError(QuestionContext.name, QuestionContext);
}
